// ./components/GyroscopeViewer.jsx
import React, { useEffect, useState, useCallback } from "react";

export default function GyroscopeViewer() {
  // Estado de permiso y datos del giro
  const [gyroStatus, setGyroStatus] = useState("idle"); 
  // "idle" | "granted" | "denied" | "error"
  const [gyroError, setGyroError] = useState(null);
  const [gyroData, setGyroData] = useState({
    alpha: null,
    beta: null,
    gamma: null,
  });

  // Handler de orientación
  const handleOrientation = useCallback((event) => {
    const { alpha, beta, gamma } = event;
    setGyroData({ alpha, beta, gamma });
  }, []);

  // Suscribirse al evento SOLO cuando el permiso está concedido
  useEffect(() => {
    if (gyroStatus !== "granted") return;

    window.addEventListener("deviceorientation", handleOrientation);

    return () => {
      window.removeEventListener("deviceorientation", handleOrientation);
    };
  }, [gyroStatus, handleOrientation]);

  // Click del botón: pedir permiso
  const requestGyroPermission = async () => {
    try {
      const isIOSDevice =
        typeof DeviceOrientationEvent !== "undefined" &&
        typeof DeviceOrientationEvent.requestPermission === "function";

      if (isIOSDevice) {
        const response = await DeviceOrientationEvent.requestPermission();
        if (response === "granted") {
          setGyroStatus("granted");
          setGyroError(null);
        } else {
          setGyroStatus("denied");
          setGyroError("El permiso fue denegado por el usuario.");
        }
      } else {
        // Otros navegadores: probamos sin pedir permiso explícito
        setGyroStatus("granted");
        setGyroError(null);
      }
    } catch (err) {
      console.error("Error al pedir permiso de giroscopio:", err);
      setGyroStatus("error");
      setGyroError(err.message || String(err));
    }
  };

  // UI
  return (
    <>
      {gyroStatus === "idle" && (
        <button onClick={requestGyroPermission}>
          Activar giroscopio
        </button>
      )}

      {gyroStatus === "granted" && (
        <>
          {gyroData.alpha === null &&
          gyroData.beta === null &&
          gyroData.gamma === null ? (
            <p>Esperando datos del giroscopio...</p>
          ) : (
            <>
              <p>giroscopio ok</p>
              <ul>
                <li>Alpha (Z): {gyroData.alpha?.toFixed(2)}</li>
                <li>Beta (X): {gyroData.beta?.toFixed(2)}</li>
                <li>Gamma (Y): {gyroData.gamma?.toFixed(2)}</li>
              </ul>
            </>
          )}
        </>
      )}

      {(gyroStatus === "denied" || gyroStatus === "error") && (
        <p>
          No se pudo acceder al giroscopio.
          {gyroError && <> ({gyroError})</>}
        </p>
      )}
    </>
  );
}
